import getColour from '@lendi-ui/commons/colours';
import Help from '@lendi-ui/icon/Help';
import Tooltip, { TooltipProps } from '@lendi-ui/tooltip';

const HelpTooltip = (props: TooltipProps) => {
  const { position = 'left', ...rest } = props;

  return (
    <Tooltip {...rest} position={position}>
      <Help color={getColour('fill', 'contrast')} />
    </Tooltip>
  );
};

export default HelpTooltip;
